import { UntypedFormControl } from '@angular/forms';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy,
  AfterViewInit,
} from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import {
  CREATE_NEW_PAGE_TYPE,
  CUSTOM_TEMPLATE_TYPE,
  Page,
  PredefinedTemplatesService,
} from '../../../services/edit/predefined-templates.service';
import { StorageService } from '../../../services/storage/storage.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RoutingService } from '../../../services/routing/routing.service';
import { LibraryService } from '../../../services/library/library.service';
import { Library } from '../../../core/interfaces/library.interface';

@Component({
  selector: 'edit-page',
  templateUrl: './edit-page.component.html',
  styleUrls: ['./edit-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditPageComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() basic = true;
  @Input() layout = false;
  @Input() pageType: CREATE_NEW_PAGE_TYPE;
  @Input() linkVars: any;
  @Output() resetNav = new EventEmitter<any>();
  @ViewChild('pageTitle') pageTitle: ElementRef;

  pageIdEdit: any;
  page: Page;

  showGuest: boolean;
  showPatron: boolean;
  showStaff: boolean;

  templateType: CUSTOM_TEMPLATE_TYPE = CUSTOM_TEMPLATE_TYPE.ABOUT_ONE;
  pageStart = true;
  editPage = false;

  general = false;
  pages = false;
  design = false;
  analytic = false;
  help = false;

  // Page Variables
  pageLayout = false;
  active = false;
  activeOnDate = false;
  publish = false;
  forceActiveState = false;

  redirect: string;
  private = false;
  newtab = false;
  pageLabel: string;
  activeDate: any = '';
  publishDate = '';
  redirectUrl: string;
  minDate: any = new Date();

  showPublishDateSettings = false;
  publishActiveOnDate = false;
  allLibs = false;
  allLibraries = new UntypedFormControl();
  allLibrariesList: Library[] = [];
  publishLibs: string[] = [];

  CSU = true;
  LSU = true;

  CREATE_NEW_PAGE_TYPE_ENUM = CREATE_NEW_PAGE_TYPE;

  constructor(
    private _storageService: StorageService,
    private _templateService: PredefinedTemplatesService,
    private _libraryService: LibraryService,
    private _router: Router,
    private _routingService: RoutingService,
    private _snackBar: MatSnackBar,
  ) {
    const user = this._storageService.getUserData();
    if (user) {
      this.CSU = user.isCustSuperUser;
      this.LSU = user.isLibSuperUser;
    }

    this.allLibrariesList = [];
    this.showGuest = true;
    this.showPatron = true;
    this.showStaff = true;
  }
  ngOnInit() {
    this.getLibraries();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pageType) {
      this.pageType = changes.pageType.currentValue;
      if (this.pageType === this.CREATE_NEW_PAGE_TYPE_ENUM.LINK) {
        this.getLibraries();
      }
      if (this.linkVars != null || this.linkVars != undefined) {
        // Pre-Populate All Variables on the Page Link when you pass this variable..
        this.pageLabel = this.linkVars.pageLabel;
        this.active = this.linkVars.active;
        this.publish = this.linkVars.publish;
        this.forceActiveState = this.linkVars.forceActiveState;
        this.redirect = this.linkVars.redirect;
      }
    }
  }
  ngAfterViewInit() {
    this.pageTitle.nativeElement.focus();
  }

  selectedTemplate(event) {
    this.templateType = event.target.value;
  }

  activate(event) {
    this.active = event.checked;
    this.activeOnDate = false;
    this.activeDate = '';
  }
  activateOnDate() {
    this.active = false;
    this.activeOnDate = true;
  }
  publishdate(event) {
    this.publish = event.checked;
    this.allLibs = false;
    this.publishLibs = []; // empty the publish to libraries array
    if (this.publish) {
      this.showPublishDateSettings = true;
      this.forceActiveState = false;
      this.publishActiveOnDate = false;
    } else {
      this.showPublishDateSettings = false;
      this.forceActiveState = false;
      this.publishActiveOnDate = false;
    }
  }
  forceActive(event) {
    this.forceActiveState = event.checked;
    this.publishActiveOnDate = false;
    this.publishDate = '';
  }
  togglePrivate(event) {
    this.private = event.checked;
  }
  toggleNewTab(event) {
    this.newtab = event.checked;
  }
  publishActivateOnDate(event) {
    this.publishActiveOnDate = event.checked;
    this.forceActiveState = false;
  }
  allLibsPublish(event) {
    this.allLibs = event.checked;
    this.publish = false;
    this.forceActiveState = false;
    this.publishActiveOnDate = false;
    if (this.allLibs) {
      this.publishLibs = []; // empty the array first to avoid duplication
      this.showPublishDateSettings = true;
      // add all libaries id to an array
      for (let index = 0; index < this.allLibrariesList.length; index++) {
        const element = this.allLibrariesList[index];
        this.publishLibs.push(element.lid);
      }
    } else {
      this.publishLibs = [];
      this.showPublishDateSettings = false;
    }
  }

  createNewPageOrWidget() {
    const doesPageLabelExist = this.pageLabel && /\S/.test(this.pageLabel);
    if (!doesPageLabelExist) {
      this.openSnackBar('enter a page label', 'ok');
      return;
    }
    if (!this.templateType) {
      this.templateType = CUSTOM_TEMPLATE_TYPE.ABOUT_ONE;
    }
    if (this.pageType === this.CREATE_NEW_PAGE_TYPE_ENUM.WIDGET) {
      this.templateType = CUSTOM_TEMPLATE_TYPE.SHOWCASE_WIDGET;
    }
    this._templateService.setNewPageLabelBS(this.pageLabel);
    this._templateService.setNewTemplate(this.templateType);
    this.resetNav.emit('true');
    this._storageService.setIsNewPage(true);
    this.closePageDialog();
    switch (this.pageType) {
      case this.CREATE_NEW_PAGE_TYPE_ENUM.WIDGET:
        this._routingService.goToEditCustomPage(this.CREATE_NEW_PAGE_TYPE_ENUM.WIDGET);
        break;
      default:
        this._routingService.goToEditCustomPage(this.CREATE_NEW_PAGE_TYPE_ENUM.PAGE);
    }
  }

  async createLinkPage(): Promise<void> {
    // this will have to use the expressAPI call to set and populate the pages links as well as the navigation.
    // We might start needing global Behavior Subjects to transmit to multiple listening observables.. aka page links and pages. idk.
    if (/\S/.test(this.redirectUrl) && /\S/.test(this.pageLabel)) {
      if (this.pageLabel.length <= 16) {
        let url;
        if (
          this.redirectUrl.includes('http://') ||
          this.redirectUrl.includes('http') ||
          this.redirectUrl.includes('https')
        ) {
          if (this.redirectUrl.includes('http://')) {
            url = this.redirectUrl.replace('http://', 'https://');
            this.redirectUrl = url;
          } else if (this.redirectUrl.includes('https') && !this.redirectUrl.includes('https://')) {
            url = this.redirectUrl.replace('https', 'https://');
            this.redirectUrl = url;
          } else if (
            this.redirectUrl.includes('http') &&
            !this.redirectUrl.includes('https://') &&
            !this.redirectUrl.includes('http://')
          ) {
            url = this.redirectUrl.replace('http', 'https://');
            this.redirectUrl = url;
          }
        } else {
          url = 'https://' + this.redirectUrl;
        }

        this.page = {
          label: this.pageLabel,
          newtab: false,
          private: false,
          linkPage: true, // qualifying character for link page
          redirectUrl: this.redirectUrl,
          showGuest: this.showGuest,
          showPatron: this.showPatron,
          showStaff: this.showStaff,
          active: this.active,
          activeDate: this.activeDate,
          activeOnDate: this.activeOnDate,
          publish: this.publish,
          publishDate: this.publishDate,
          publishToAllLibs: this.allLibs,
          publishActiveOnDate: this.publishActiveOnDate,
          templates: [
            {
              components: [],
            },
          ],
          homeDate: '',
          publishToCertainLids: [],
          sharedWith: '',
        };

        const createLibraryPayload: any = {};
        createLibraryPayload.cid = this._storageService.getCid();
        createLibraryPayload.lid = this._storageService.getLid();
        createLibraryPayload.pages = this.page;

        // call api endpoint, maybe a new of old the old one to save library
        // old one is preferable
        // flag to check library Exists or not. this flag is set in home.comp.ts

        const postbody = {
          cid: this._storageService.getCid(),
          lid: this._storageService.getLid(),
          forceActive: this.forceActiveState,
          libraries: [],
          pages: this.page,
        };

        if (this._storageService.getItem('libExists')) {
          // ------- pageId is onavailable for editing an existing page ----------
          if (this.pageIdEdit == undefined) {
            this.pageIdEdit = 0;
          }

          const addPageToLibraryPayload = {
            cid: this._storageService.getCid(),
            lid: this._storageService.getLid(),
            libId: this._storageService.getItem('libId'),
            pageId: this.pageIdEdit,
            page: this.page,
          };

          const response =
            await this._templateService.addPageToLibraryAsync(addPageToLibraryPayload);
          if (response?.status === '200 OK') {
            // -------------------- this is to set the home page -----------------
            this.openSnackBar(response.message, 'ok');
            this.closePageDialog();

            // --------------------- Check for Publish ------------------------

            if (this.publish && !this.allLibs) {
              //
              // make page visibility true for all users
              //
              this.page.showGuest = true;
              this.page.showPatron = true;
              this.page.showStaff = true;
              if (this.allLibraries.value) {
                const targetNameOnly = this._storageService.getUserData().libraryName;
                const targetLid = this._storageService.getLid();
                const targetName =
                  this._storageService.getUserData().libraryName +
                  '(' +
                  this._storageService.getLid() +
                  ')';
                this.page.targetLibForPublishedPage = targetName;
                this.page.targetLibName = targetNameOnly;
                this.page.targetLibLid = targetLid;
                postbody['libraries'] = this.allLibraries.value;
              }
            } else if (!this.publish && this.allLibs) {
              if (this.publishLibs.length > 0) {
                const targetNameOnly = this._storageService.getUserData().libraryName;
                const targetLid = this._storageService.getLid();
                this.page.targetLibName = targetNameOnly;
                this.page.targetLibLid = targetLid;
                postbody['libraries'] = this.publishLibs;
              }
            }

            if (this.publish || this.allLibs) {
              this._templateService.setPublish(postbody).subscribe((response) => {
                this.openSnackBar(response.message, 'ok');
              });
            }
          }
        } else {
          const response = await this._templateService.createLibraryAsync(createLibraryPayload);
          this.openSnackBar(response.message, 'ok');
          if (response.data.length && this.publish) {
            postbody['libraries'] = this.allLibraries.value;
            this._templateService.setPublish(postbody).subscribe((response) => {
              this.openSnackBar(response.message, 'ok');
            });
          }
        }
      } else {
        this.openSnackBar('Title cannot be greater than 16 characters', 'ok');
      }
    } else {
      this.openSnackBar('Enter the redirect Url and page Link Title', 'ok');
    }
  }

  getLibraries() {
    this._libraryService.getLibraries().subscribe((libraries) => {
      this.allLibrariesList = [];
      for (let index = 0; index < libraries.length; index++) {
        const element = libraries[index];
        this.allLibrariesList.push(element);
      }
      // remove the current lid
      const currentLidIndex = this.allLibrariesList.findIndex(
        (item) => item.lid.toUpperCase() === this._storageService.getLid(),
      );
      if (currentLidIndex > -1) {
        this.allLibrariesList.splice(currentLidIndex, 1);
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 15000,
      verticalPosition: 'top',
    });
  }

  closePageDialog() {
    this.resetNav.emit('true');
    $('#edit-overlay').fadeOut(100);
    $('.control-panel-dialog').fadeOut(500);
    $('html').css('overflow-y', 'auto');
    $('.mat-drawer-shown').click();
  }
  closeOverlay() {
    $('#edit-overlay').fadeOut(100);
    $('.control-panel-dialog').fadeOut(500);
    $('html').css('overflow-y', 'auto');
  }
}
